import type { UtilityConfidence, UtilityService } from "@shared/api";

/** Display order matches `inferUtilities` and the Utilities Figma rows. */
export const UTILITY_SERVICES_ORDER: UtilityService[] = [
  "water",
  "sewer",
  "electric",
  "gas",
  "internet"
];

export function serviceTitle(service: UtilityService): string {
  switch (service) {
    case "water":
      return "Water";
    case "sewer":
      return "Sewer";
    case "electric":
      return "Electric";
    case "gas":
      return "Gas";
    case "internet":
      return "Internet";
  }
}

export function confidenceShortLabel(confidence: UtilityConfidence): string {
  switch (confidence) {
    case "verified-available":
      return "Verified";
    case "likely-available":
      return "Likely";
    case "likely-unavailable":
      return "Unlikely";
    case "unknown":
      return "Unknown";
    default: {
      const _exhaustive: never = confidence;
      return _exhaustive;
    }
  }
}
